module.exports = __webpack_public_path__ + "media/src/images/icons/gift-outline-eb43cc733471f38765505ba594863b89.svg";